import { urlForImage } from '@/sanity/lib/image'
import Image from 'next/image'

const ImageSmall = ({ image }) => {
  const base = 'relative flex-1 basis-0 w-full mx-auto lg:m-0 max-w-[205px] md:max-w-[290px] aspect-[3/4]'
  return (
    <div className={base}>
      <Image
        src={urlForImage(image).url()}
        alt={image.alt}
        fill
        placeholder="blur"
        blurDataURL={image.metadata.lqip}
        className="object-cover"
      />
    </div>
  )
}

export default ImageSmall
